import { render, staticRenderFns } from "./EditContact.vue?vue&type=template&id=16015ca8&"
import script from "./EditContact.vue?vue&type=script&lang=ts&"
export * from "./EditContact.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports